import { devtools } from 'zustand/middleware';
import { create } from 'store/create';
import type { ActivePickTarget, CrossReferencePickStore, PickResolution } from './types';

export const useCrossReferencePickStore = create<CrossReferencePickStore>()(
  devtools(
    (set, get) => ({
      activeTarget: null,

      setTarget: (target: ActivePickTarget) =>
        set(
          state => {
            // Fire prior cancel before swapping.
            if (state.activeTarget && state.activeTarget.targetId !== target.targetId) {
              state.activeTarget.onCancel?.();
            }
            return { activeTarget: target };
          },
          false,
          'setTarget'
        ),

      clearTarget: () => set({ activeTarget: null }, false, 'clearTarget'),

      resolve: (resolved: PickResolution) => {
        const target = get().activeTarget;
        if (!target) {
          return;
        }
        target.onPicked(resolved);
        set({ activeTarget: null }, false, 'resolve');
      },

      cancel: () => {
        const target = get().activeTarget;
        if (!target) {
          return;
        }
        target.onCancel?.();
        set({ activeTarget: null }, false, 'cancel');
      },
    }),
    { name: 'useCrossReferencePickStore' }
  )
);
